/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'confluence-table-tree.column.contributors': 'Přispěvatelé',
  'confluence-table-tree.column.last-modified': 'Naposledy změněno',
  'confluence-table-tree.column.title': 'Název',
  'confluence-table-tree.could-not-load': 'Nelze načíst',
  'confluence-table-tree.could-not-load-contributors': 'Načtení přispěvatelů se nezdařilo.',
  'confluence-table-tree.create-child-page': 'Vytvořit podřazenou stránku',
  'confluence-table-tree.create-page': 'Vytvořit stránku',
  'confluence-table-tree.default.page.title': 'Bez názvu',
  'confluence-table-tree.default.show-all-pages-button.label': 'Zobrazit více stránek',
  'confluence-table-tree.draft.lozenge': 'KONCEPT',
  'confluence-table-tree.draft.tooltip': 'Koncepty uvidíte pouze vy.',
  'confluence-table-tree.drafts-toggle.label': 'Zobrazit koncepty',
  'confluence-table-tree.edit': 'Upravit',
  'confluence-table-tree.edit-in-confluence': 'Upravit v Confluence',
  'confluence-table-tree.empty.description':
    'Tento prostor se zaplní, až začnete vytvářet zápisy ze schůzek, produktové požadavky, rozhodnutí a další obsah.',
  'confluence-table-tree.empty.title': 'Nic zde není, ale může být',
  'confluence-table-tree.error.description': 'Tyto stránky vám nemůžeme zobrazit. Zkuste to znovu později.',
  'confluence-table-tree.error.row': 'Načtení stránek se nezdařilo.',
  'confluence-table-tree.error.title': 'Hmm, toto je zvláštní…',
  'confluence-table-tree.friendly-when-created': 'Vytvořeno',
  'confluence-table-tree.friendly-when-updated': 'Aktualizováno',
  'confluence-table-tree.share.copied': 'Zkopírováno do schránky',
  'confluence-table-tree.share.copy-button': 'Kopírovat',
  'confluence-table-tree.share.subtitle': 'Sdílejte tento odkaz',
  'confluence-table-tree.share.title': 'Sdílet stránku',
  'confluence-table-tree.share.tooltip': 'Sdílet',
  'confluence-table-tree.view-profile': 'Zobrazit profil',
};
